import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

export const IconRuler: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconRuler"><G ClipPath="url(#clip0_6508_53972)"><Path d="M12.3741 4.31354L15.9982 0.689453L23.3088 8.00011L7.99816 23.3108L0.6875 16.0001L4.31342 12.3742L7 15.0608L8.06066 14.0001L5.37408 11.3135L7.81342 8.8742L11.5 12.5608L12.5607 11.5001L8.87408 7.81354L11.3134 5.3742L14 8.06078L15.0607 7.00012L12.3741 4.31354Z" fill="currentColor"/></G><Defs><ClipPath id="clip0_6508_53972"><Rect width="24" height="24" fill="white"/></ClipPath></Defs></CentralIconBase>;
});

export default IconRuler;
